import * as S from '../app/state';
import { t, LANGS, lang, setLang } from '../i18n';
import { Btn } from './common';
import { prefs, setPref, type Prefs } from '../app/prefs';
import { audio } from '../game/audio';
import { api } from '../net/api';
import { resetHints } from '../app/hints';
import { fullscreenOn, refreshDeviceClasses, toggleFullscreen } from '../app/device';
import { game } from '../game/client';

function Slider(props: { k: 'master' | 'sfx' | 'music'; label: string }) {
  return (
    <div class="setting">
      <span>{props.label}</span>
      <input
        type="range"
        min={0}
        max={1}
        step={0.05}
        value={prefs.value[props.k]}
        onInput={(e) => {
          setPref(props.k, parseFloat((e.target as HTMLInputElement).value));
          audio.applyVolumes();
        }}
      />
    </div>
  );
}

function Toggle(props: { k: keyof Prefs; label: string }) {
  return (
    <div class="setting">
      <span>{props.label}</span>
      <label class="row clickable" style={{ justifyContent: 'flex-end' }}>
        <input type="checkbox" checked={!!prefs.value[props.k]} onChange={(e) => setPref(props.k, (e.target as HTMLInputElement).checked as never)} />
      </label>
    </div>
  );
}

export function Settings() {
  return (
    <div class="screen">
      <div class="card narrow panel col tall">
        <div class="row">
          <h2>{t('btn.settings')}</h2>
          <div class="grow" />
          <Btn small onClick={() => (S.screen.value = 'home')}>
            {t('btn.back')}
          </Btn>
        </div>
        <div class="setting">
          <span>
            {t('set.touch')}
            <div class="small muted">{t('set.touchHint')}</div>
          </span>
          <select
            value={prefs.value.touch ?? 'auto'}
            onChange={(e) => {
              setPref('touch', (e.target as HTMLSelectElement).value as 'auto' | 'on' | 'off');
              refreshDeviceClasses();
              game.applyControlMode();
            }}
          >
            <option value="auto">{t('set.touch.auto')}</option>
            <option value="on">{t('set.touch.on')}</option>
            <option value="off">{t('set.touch.off')}</option>
          </select>
        </div>
        <div class="setting">
          <span>{t('set.fullscreen')}</span>
          <div class="row" style={{ justifyContent: 'flex-end' }}>
            <Btn small onClick={() => void toggleFullscreen()}>
              {fullscreenOn.value ? t('btn.fullscreenOff') : t('btn.fullscreenOn')}
            </Btn>
          </div>
        </div>
        <div class="setting">
          <span>{t('label.language')}</span>
          <select
            value={lang.value}
            onChange={(e) => {
              const l = (e.target as HTMLSelectElement).value as typeof lang.value;
              void setLang(l);
              if (S.conn.value === 'online') void api.updateMe({ lang: l }).then((a) => (S.account.value = a)).catch(() => {});
            }}
          >
            {LANGS.map((l) => (
              <option value={l.id}>{l.label}</option>
            ))}
          </select>
        </div>
        <Slider k="master" label={t('set.master')} />
        <Slider k="sfx" label={t('set.sfx')} />
        <Slider k="music" label={t('set.music')} />
        <Toggle k="shake" label={t('set.shake')} />
        <Toggle k="dmgNumbers" label={t('set.dmg')} />
        <Toggle k="names" label={t('set.names')} />
        <Toggle k="minimap" label={t('set.minimap')} />
        <Toggle k="dimOthers" label={t('set.othersProj')} />
        <div class="setting">
          <span>{t('label.hints')}</span>
          <div class="row" style={{ justifyContent: 'flex-end' }}>
            <Btn
              small
              onClick={() => {
                resetHints();
                S.showToast(t('toast.hintsReset'));
              }}
            >
              {t('btn.resetHints')}
            </Btn>
          </div>
        </div>
        <div class="sep" />
        <h3>{t('label.controls')}</h3>
        <div class="controls">
          <span>{t('ctl.move')}</span>
          <span>W A S D / ←↑→↓</span>
          <span>{t('ctl.aim')}</span>
          <span>Mouse</span>
          <span>{t('ctl.fire')}</span>
          <span>LMB</span>
          <span>{t('ctl.dash')}</span>
          <span>Space / Shift</span>
          <span>{t('ctl.skills')}</span>
          <span>Q E R F (RMB = 1)</span>
          <span>{t('ctl.cons')}</span>
          <span>1 2 3 4</span>
          <span>{t('ctl.pick')}</span>
          <span>Z X C V B</span>
          <span>{t('ctl.interact')}</span>
          <span>G</span>
          <span>{t('ctl.build')}</span>
          <span>Tab</span>
          <span>{t('ctl.chat')}</span>
          <span>Enter</span>
          <span>{t('ctl.menu')}</span>
          <span>Esc</span>
          <span>{t('ctl.map')}</span>
          <span>M</span>
          <span>{t('ctl.autofire')}</span>
          <span>I</span>
        </div>
        <div class="small muted">{t('label.settingsHint')}</div>
      </div>
    </div>
  );
}
